import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import secureLocalStorage from "react-secure-storage";
import verifytoken from "../../env/verifytoken";
import { config } from "../../utils/config";
import Sidebar from "../../components/Sidebar";
import VariationCountPopup from "../../components/VariationCountPopup";
import VariationCountLabel from "../../components/VariationCountLabel";
import PrivateFooter from "../../components/PrivateFooter";
import moment from "moment";
import {
  designWiseSizeDimensions,
  getSubscriptionStatus,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { setDimensions } from "../../redux/slices/SizeSlice";
import { removeFromIndexedDB } from "../../utils/indexedDB";
import {
  setPlanDetails,
  updateName,
  updateNum,
} from "../../redux/slices/PlanDetailSlice";
import KEYS from "../../env/env";
import {
  resetExcelInfo,
  setTshirtDetails,
  setExcelInfo,
} from "../../redux/slices/variationSlice";
import { createDesign, getDesignsList } from "../../redux/slices/DesignSlice";
import Modal from "../../components/modal";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import InternetSpeedIndicator from "../../components/InternetSpeedIndicator";
import { trackAnalyticsEvent } from "../../utils/analytics";
import AppVersionSwitch from "../../components/AppVersionSwitch";

function Home({ store }) {
  const dispatch = useDispatch();
  const { designs, pagination } = useSelector((state) => state.design);
  const userPlanDetails = useSelector((state) => state.userPlan);
  const userData = useSelector((state) => state.user.userData);
  // console.log("userPlanDetails is ", userPlanDetails);
  const [loading, setLoading] = useState(false);
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);
  const [showVariationCountPopup, setShowVariationCountPopup] = useState(false);
  const [variationCountLeft, setVariationCountLeft] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [newDesignName, setNewDesignName] = useState("");
  const [selectedDesignId, setSelectedDesignId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [localUI, setLocalUI] = useState({
    isSubmitting: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const aSizes = ["a4", "a3", "a2", "a1"];

  const trackRootDesignSelection = (selectedType, source, extra = {}) => {
    trackAnalyticsEvent("root_design_type_selected", {
      selected_type: selectedType,
      source,
      ...extra,
    });
  };

  useEffect(() => {
    dispatch(getDesignsList());
  }, []);

  // var token = secureLocalStorage.getItem("Login");
  var token = localStorage.getItem("Login");
  const [customWidth, setCustomWidth] = useState("12.5");
  const [customHeight, setCustomHeight] = useState("12.5");
  const [focusedInput, setFocusedInput] = useState(null);
  const widthRef = useRef(null);
  const heightRef = useRef(null);

  // Detect outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        widthRef.current &&
        !widthRef.current.contains(event.target) &&
        heightRef.current &&
        !heightRef.current.contains(event.target)
      ) {
        setFocusedInput(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUserRedirection = async () => {
    const token = localStorage.getItem("Login");

    // Case 1: Magic link / invite with token + email in URL
    if (queryParams.get("token") && queryParams.get("email")) {
      const inviteToken = queryParams.get("token");
      const email = queryParams.get("email");
      const isNewUser = queryParams.get("isNewUser") === "true";

      localStorage.setItem("Login", inviteToken);
      // optional: localStorage.setItem("token", inviteToken); // if you still need separate "token"

      try {
        await callUserDataApi(inviteToken, email);
      } catch (err) {
        console.error("Failed to fetch user data after invite", err);
        toast.error("Failed to load user data. Please try logging in normally.");
        navigate("/Login", { replace: true });
        return;      }

      // Redirect based on new/existing user
      if (isNewUser) {
        navigate("/plans", { replace: true });
      } else {
        navigate("/", { replace: true }); 
      }
      return; // stop further checks
    }

    // Case 2: No token at all → go to login
    if (!token) {
      navigate("/Login", { replace: true });
      return;
    }

    // Case 3: Token exists → validate it
    const isTokenExpired = verifytoken(); // true = expired / invalid

    // Optional: clear sensitive data when logging out / token invalid
    if (isTokenExpired) {
      localStorage.removeItem("Login");
      localStorage.removeItem(config.USER_LOGIN_DETAILS);
      localStorage.removeItem(config.USER_PLAN_DETAILS);
      localStorage.removeItem(config.VARIANT_COUNT);
      navigate("/Login", { replace: true });
    }

    // Case 4: Valid token → check plan/subscription status → show popup if needed
    let planDetails = null;

    const userPlanRaw = localStorage.getItem(config.USER_PLAN_DETAILS);

    if (userPlanRaw && userPlanRaw !== "undefined" && userPlanRaw !== "null") {
      try {
        const parsed = JSON.parse(userPlanRaw);

        if (Array.isArray(parsed)) {
          planDetails = parsed[0] || null;
        } else if (typeof parsed === "object" && parsed !== null) {
          planDetails = parsed;
        }
      } catch (err) {
        console.error("Failed to parse user plan details:", err);
      }
    }

    if (planDetails) {
      if ([1, 5].includes(+planDetails.plan_id)) {
        const total = parseInt(planDetails.total_variant || 0, 10);
        const downloaded = parseInt(planDetails.variant_count || 0, 10);
        const remaining = total - downloaded;

        setShowVariationCountPopup(remaining < 4);
      } else {
        const status = getSubscriptionStatus(planDetails);
        setShowVariationCountPopup(status === "Subscription expired");
      }
    } else {
      console.warn("No valid plan details found in localStorage");
      setShowVariationCountPopup(false);
    }

    // Optional: update variation count if you still need it
    const variantRaw = localStorage.getItem(config.VARIANT_COUNT);
    if (variantRaw && variantRaw !== "undefined" && variantRaw !== "null") {
      try {
        const variantData = JSON.parse(variantRaw);
        setVariationCountLeft(variantData?.remaning || 0);
      } catch (err) {
        console.error("Failed to parse variant count:", err);
      }
    }
  };

  useEffect(() => {
    handleUserRedirection();
  }, [token]);

  const callUserDataApi = async (token, email) => {
    try {
      setLoading(true);
      let data = {
        email: email,
      };
      let response = await fetch(KEYS.apiPath + "user/data", {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      let val = await response.json();
      // console.log("val?.response?.user", val?.response?.user);
      if (+val.resultFlag === 1) {
        let user = val?.response?.user;
        // secureLocalStorage.setItem("Login", val?.response?.token);
        let userDetails = val?.response?.user;
        let userPlanDetails = val?.response?.userPlan;
        let variants = val?.response?.variants;

        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(userDetails)
        );
        localStorage.setItem(
          config.USER_PLAN_DETAILS,
          JSON.stringify(userPlanDetails)
        );
        if (variants) {
          localStorage.setItem(config.VARIANT_COUNT, JSON.stringify(variants));
          dispatch(setPlanDetails({ userPlanDetails: userPlanDetails }));
        }
        //  console.log("going to redirect to home");
      }
    } catch (e) {
      toast.error(`Error in getting user details: ${e}`);
    } finally {
      setLoading(false);
    }
  };

  localStorage.removeItem("bgImageDetails");
  localStorage.removeItem("playernamedetails");
  localStorage.removeItem("tshirtDetails");
  localStorage.removeItem("playernumberdetails");
  localStorage.removeItem("tshirtchangedetails");
  localStorage.removeItem("bgname");

  // Add click handler to close menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const menus = document.querySelectorAll(".more-menu");
      menus.forEach((menu) => {
        if (
          !menu.contains(event.target) &&
          !event.target.closest(".more-button")
        ) {
          menu.style.display = "none";
        }
      });
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // Rename Design
  const handleDesignRename = async (e) => {
    e.preventDefault();
    if (newDesignName.trim()) {
      try {
        setLocalUI({
          ...localUI,
          isSubmitting: true,
        });
        const response = await fetch(
          KEYS.apiPath + "design/update/" + selectedDesignId,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              design_name: newDesignName,
            }),
          }
        );
        const data = await response.json();
        if (data.resultFlag === 1) {
          setShowModal(false);
          setNewDesignName("");
          setSelectedDesignId(null);
          dispatch(getDesignsList());
          setLocalUI({
            ...localUI,
            isSubmitting: false,
          });
        }
      } catch (error) {
        setLocalUI({
          ...localUI,
          isSubmitting: false,
        });
        console.error("Error:", error);
      }
    }
  };
  // Delete Design
  const handleDesignDelete = async () => {
    try {
      setLocalUI({
        ...localUI,
        isSubmitting: true,
      });
      const response = await fetch(
        KEYS.apiPath + "design/delete/" + selectedDesignId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.resultFlag === 1) {
        setShowDeleteModal(false);
        setSelectedDesignId(null);
        dispatch(getDesignsList());
        setLocalUI({
          ...localUI,
          isSubmitting: false,
        });
      }
    } catch (error) {
      setLocalUI({
        ...localUI,
        isSubmitting: false,
      });
      console.error("Error:", error);
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <BeatLoader color="#2A1FB3" size={10} />
      </div>
    );
  }

  return (
    <>
      {showVariationCountPopup && (
        <VariationCountPopup close={() => setShowVariationCountPopup(false)} />
      )}
      {showModal && (
        <Modal
          close={() => {
            setShowModal(false);
          }}
        >
          <form
            style={{
              width: "20vw",
              gap: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
            onSubmit={handleDesignRename}
          >
            <h5>Rename Design</h5>
            <input
              type="text"
              className="form-control"
              value={newDesignName}
              onChange={(e) => setNewDesignName(e.target.value)}
              placeholder="Enter design name"
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setShowModal(false);
                  setNewDesignName("");
                  setSelectedDesignId(null);
                }

                // if (e.key === "Enter" && newDesignName.trim()) {
                //     setShowModal(false);
                //     setNewDesignName("");
                //     setSelectedDesignId(null);
                // } else if (e.key === "Escape") {
                //     setShowModal(false);
                //     setNewDesignName("");
                //     setSelectedDesignId(null);
                // }
              }}
              autoFocus
            />
            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  setShowModal(false);
                  setNewDesignName("");
                  setSelectedDesignId(null);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                // onClick={handleDesignRename}
                disabled={localUI.isSubmitting}
              >
                {localUI.isSubmitting ? "Renaming..." : "Rename"}
              </button>
            </div>
          </form>
        </Modal>
      )}
      {showDeleteModal && (
        <Modal
          close={() => {
            setShowDeleteModal(false);
          }}
        >
          <div
            style={{
              width: "20vw",
              gap: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h5>Delete Design</h5>
            <p>
              Are you sure you want to delete <strong>{newDesignName}</strong>{" "}
              design?
            </p>
            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedDesignId(null);
                  setNewDesignName("");
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDesignDelete}
                disabled={localUI.isSubmitting}
              >
                {localUI.isSubmitting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal>
      )}
      <div id="main-container" className="container-fluid main">
        <div className="left-main-menu">
          <Sidebar />
        </div>
        <section className="home " style={{ paddingLeft: 0 }}>
          <div className="upgradeButtonFixed">
            <VariationCountLabel userPlanDetails={userPlanDetails} />
            <InternetSpeedIndicator />
<AppVersionSwitch />
          </div>

          {/* <div className="storage-info">
                        <span>20MB</span>/<span>500MB</span>Storage
                    </div>
                */}
          <div className="page-text adjust-top">
            <h5>
              <span>Design</span>
              <span>Variation</span>
              <span>Export</span>
            </h5>
            <h1>Select your Teeshirt side</h1>
            {/* <p>
              Create your own customized jersey with personalized player names
              and auto-generated number variations. Add custom text, upload
              logos, and more to make your jersey unique.
            </p> */}
          </div>
          <div className="select-type-list">
            <div
              className="select-type-block"
              onClick={async () => {
                trackRootDesignSelection("back", "jersey_design_card");
                try {
                  // Clear the design data from IndexedDB
                  await removeFromIndexedDB("designs", "polotnoDesignImages");
                  await removeFromIndexedDB("designs", "polotnoDesignStore");

                  // Set dimensions and navigate
                  dispatch(
                    setDimensions({
                      dimensions: designWiseSizeDimensions["back"],
                      selectedType: "back",
                    })
                  );
                  dispatch(updateName(false));
                  dispatch(updateNum(false));

                  localStorage.setItem("selectedType", "back");
                  localStorage.removeItem("applyAllClickStatusTees");
                  localStorage.removeItem("excelInfo");
                  dispatch(setTshirtDetails([]));
                  dispatch(setExcelInfo(null));
                  dispatch(resetExcelInfo());
                  store.clear();
                  // navigate("/Design?boardType=new", {
                  //     state: { side: "back" },
                  // });

                  let payload = {
                    design_name: `Design ${new Date().toLocaleDateString()}`,
                    // store_data: {},
                    // design_thumbnail: null
                  };

                  payload.redirect_to = "design_page";

                  await dispatch(
                    createDesign({
                      designData: payload,
                      navigate: navigate,
                      newTab: true,
                    })
                  ).unwrap();

                  // window.open(
                  //     "/Design?boardType=new",
                  //     "_blank"
                  // );
                } catch (error) {
                  console.error("Error clearing design data:", error);
                  // Still proceed with navigation even if clearing fails
                  await removeFromIndexedDB("designs", "polotnoDesignImages");
                  await removeFromIndexedDB("designs", "polotnoDesignStore");

                  dispatch(
                    setDimensions({
                      dimensions: designWiseSizeDimensions["back"],
                      selectedType: "back",
                    })
                  );
                  localStorage.setItem("selectedType", "back");
                  store.clear();
                  navigate("/Design?boardType=new", {
                    state: { side: "back" },
                  });
                }
              }}
            >
              <div className="select-type-item">
                <div className="select-type-item-img">
                  <img src={"/assets/images/backside-teeshirt.png"} alt="" />
                </div>
                <div className="select-type-item-text">
                  <h3>Jersey Design</h3>
                  <p>
                    Create custom jerseys with player names, numbers, text, and
                    logos.
                  </p>
                </div>
                <span>Start Your Design</span>
              </div>
            </div>
            <div
              className="select-type-block"
              onClick={async () => {
                trackRootDesignSelection("halfSleeves", "half_sleeve_card");
                dispatch(
                  setDimensions({
                    dimensions: designWiseSizeDimensions["halfSleeves"],
                    selectedType: "halfSleeves",
                  })
                );
                await removeFromIndexedDB("designs", "polotnoDesignImages");
                await removeFromIndexedDB("designs", "polotnoDesignStore");
                dispatch(updateName(false));
                dispatch(updateNum(false));
                dispatch(setTshirtDetails([]));
                dispatch(setExcelInfo(null));
                localStorage.setItem("selectedType", "halfSleeves");
                localStorage.removeItem("applyAllClickStatushalfSleeves");
                localStorage.removeItem("excelInfo");
                dispatch(resetExcelInfo());
                store.clear();
                // navigate("/Design?boardType=new", {
                //     state: { side: "back" },
                // });

                // create design
                let payload = {
                  design_name: `Design ${new Date().toLocaleDateString()}`,
                  // store_data: {},
                  // design_thumbnail: null
                };

                payload.redirect_to = "design_page";

                await dispatch(
                  createDesign({
                    designData: payload,
                    navigate: navigate,
                    newTab: true,
                  })
                ).unwrap();

                // window.open("/Design?boardType=new", "_blank");
              }}
            >
              <div className="select-type-item">
                <div className="select-type-item-img">
                  <img src={"/assets/images/half-sleeve-teeshirt.png"} alt="" />
                </div>
                <div className="select-type-item-text">
                  <h3>Half Sleeve</h3>
                  <p>
                    Customize your jersey sleeve and add text, upload logos,
                    etc.
                  </p>
                </div>
                <span>Start Your Design</span>
              </div>
            </div>
            <div
              className="select-type-block"
              onClick={async () => {
                trackRootDesignSelection("fullSleeves", "full_sleeve_card");
                dispatch(
                  setDimensions({
                    dimensions: designWiseSizeDimensions["fullSleeves"],
                    selectedType: "fullSleeves",
                  })
                );
                await removeFromIndexedDB("designs", "polotnoDesignImages");
                await removeFromIndexedDB("designs", "polotnoDesignStore");
                dispatch(updateName(false));
                dispatch(updateNum(false));
                dispatch(setTshirtDetails([]));
                dispatch(setExcelInfo(null));
                localStorage.setItem("selectedType", "fullSleeves");
                localStorage.removeItem("applyAllClickStatusfullSleeves");
                localStorage.removeItem("excelInfo");
                dispatch(resetExcelInfo());
                store.clear();
                // navigate("/Design?boardType=new", {
                //     state: { side: "back" },
                // });

                // create design
                let payload = {
                  design_name: `Design ${new Date().toLocaleDateString()}`,
                  // store_data: {},
                  // design_thumbnail: null
                };

                payload.redirect_to = "design_page";

                await dispatch(
                  createDesign({
                    designData: payload,
                    navigate: navigate,
                    newTab: true,
                  })
                ).unwrap();

                // window.open("/Design?boardType=new", "_blank");
              }}
            >
              <div className="select-type-item">
                <div className="select-type-item-img">
                  <img src={"/assets/images/full-sleeve-teeshirt.png"} alt="" />
                </div>
                <div className="select-type-item-text">
                  <h3>Full Sleeve</h3>
                  <p>
                    Customize your full sleeve design with text, logos, and
                    graphics effortlessly.
                  </p>
                </div>
                <span>Start Your Design</span>
              </div>
            </div>

            {/*  */}
            <div className="select-type-block">
              <div className="select-type-item">
                <div className="select-type-item-img">
                  <img src={"/assets/images/a4size-teeshirt.png"} alt="" />
                </div>
                <div className="select-type-item-text">
                  <h3>
                    A4
                    <select
                      className="a-size-select"
                      onChange={async (e) => {
                        trackRootDesignSelection(
                          e.target.value,
                          "paper_size_dropdown"
                        );
                        dispatch(
                          setDimensions({
                            dimensions: [],
                            selectedType: e.target.value,
                          })
                        );
                        await removeFromIndexedDB(
                          "designs",
                          "polotnoDesignImages"
                        );
                        await removeFromIndexedDB(
                          "designs",
                          "polotnoDesignStore"
                        );
                        dispatch(updateName(false));
                        dispatch(updateNum(false));
                        dispatch(setTshirtDetails([]));
                        dispatch(setExcelInfo(null));
                        localStorage.removeItem("excelInfo");
                        dispatch(resetExcelInfo());
                        localStorage.setItem("selectedType", e.target.value);
                        store.clear();

                        // create design
                        let payload = {
                          design_name: `Design ${new Date().toLocaleDateString()}`,
                          // store_data: {},
                          // design_thumbnail: null
                        };

                        payload.redirect_to = "design_page";

                        await dispatch(
                          createDesign({
                            designData: payload,
                            navigate: navigate,
                            newTab: true,
                          })
                        ).unwrap();

                        // navigate(
                        //     "/Design?boardType=new",
                        //     {
                        //         state: { side: "back" },
                        //     }
                        // );
                        // window.open(
                        //     "/Design?boardType=new",
                        //     "_blank"
                        // );
                      }}
                    >
                      <option value="">Select Size</option>

                      {aSizes.map((size, index) => (
                        <option key={index} value={size}>
                          {size.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </h3>
                  <p>
                    Automate player name and number variation in A4 size. Add
                    text, upload logos, etc.
                  </p>
                </div>
                <span>Start Your Design</span>
              </div>
            </div>

            {/* Commented custom size for now */}

            <div className="select-type-block">
              <div className="select-type-item">
                <div className="select-type-item-img">
                  <h5>Width</h5>
                  <div
                    className="artboard--main__sizes--item--box--data--list"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      ref={widthRef}
                      className={`data-size-width input-container ${
                        focusedInput === "width" ? "focused" : ""
                      }`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {focusedInput === "width" && (
                        <div className="button-container">
                          <button
                            type="button"
                            className="decrease"
                            onClick={() => {
                              const currentValue = parseFloat(customWidth) || 0;
                              setCustomWidth((currentValue - 1).toString());
                            }}
                          ></button>
                          <button
                            type="button"
                            className="increase"
                            onClick={() => {
                              const currentValue = parseFloat(customWidth) || 0;
                              setCustomWidth((currentValue + 1).toString());
                            }}
                          ></button>
                        </div>
                      )}
                      <input
                        type="number"
                        placeholder="Width"
                        value={customWidth}
                        onChange={(e) => {
                          setCustomWidth(e.target.value);
                        }}
                        style={{
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          width: "110px",
                        }}
                        onFocus={() => setFocusedInput("width")}
                      />
                    </div>
                  </div>
                  <h5>Height</h5>
                  <div
                    className="artboard--main__sizes--item--box--data--list"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      ref={heightRef}
                      className={`data-size-width input-container ${
                        focusedInput === "height" ? "focused" : ""
                      }`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {focusedInput === "height" && (
                        <div className="button-container">
                          <button
                            type="button"
                            className="decrease"
                            onClick={() => {
                              const currentValue =
                                parseFloat(customHeight) || 0;
                              setCustomHeight((currentValue - 1).toString());
                            }}
                          ></button>
                          <button
                            type="button"
                            className="increase"
                            onClick={() => {
                              const currentValue =
                                parseFloat(customHeight) || 0;
                              setCustomHeight((currentValue + 1).toString());
                            }}
                          ></button>
                        </div>
                      )}

                      <input
                        type="number"
                        placeholder="Height"
                        value={customHeight}
                        onChange={(e) => {
                          setCustomHeight(e.target.value);
                        }}
                        style={{
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          width: "110px",
                        }}
                        onFocus={() => setFocusedInput("height")}
                      />
                    </div>
                  </div>
                </div>
                <div className="select-type-item-text">
                  <h3>Custom Size</h3>
                  <p>
                    Customize your full sleeve design with text, logos, and
                    graphics effortlessly.
                  </p>
                </div>
                <span>
                  <button
                    type="button"
                    style={{
                      background: "none",
                      border: "none",
                    }}
                    onClick={async () => {
                      trackRootDesignSelection("custom", "custom_size", {
                        width: customWidth,
                        height: customHeight,
                      });
                      dispatch(
                        setDimensions({
                          dimensions: [],
                          selectedType: "custom",
                        })
                      );
                      await removeFromIndexedDB(
                        "designs",
                        "polotnoDesignImages"
                      );
                      await removeFromIndexedDB(
                        "designs",
                        "polotnoDesignStore"
                      );
                      dispatch(updateName(false));
                      dispatch(updateNum(false));
                      dispatch(setTshirtDetails([]));
                      dispatch(setExcelInfo(null));
                      localStorage.removeItem("excelInfo");
                      dispatch(resetExcelInfo());
                      localStorage.setItem("selectedType", "custom");
                      localStorage.setItem("customHeight", customHeight);
                      localStorage.setItem("customWidth", customWidth);
                      store.clear();

                      // create design
                      let payload = {
                        design_name: `Design ${new Date().toLocaleDateString()}`,
                        // store_data: {},
                        // design_thumbnail: null
                      };

                      payload.redirect_to = "design_page";

                      await dispatch(
                        createDesign({
                          designData: payload,
                          navigate: navigate,
                          newTab: true,
                        })
                      ).unwrap();

                      // window.open(
                      //     "/Design?boardType=new",
                      //     "_blank"
                      // );
                    }}
                  >
                    Start Your Design
                  </button>
                </span>
              </div>
            </div>

            {/* End Commented custom size for now */}
          </div>
          {/* Your Design section */}
          <div className="your-design-section">
            <div className="your-design-section-head">
              {/* {designs?.length > 0 && ( */}
              <h4>
                <img src={"/assets/images/folder_open_icon.svg"} alt="" /> Your
                Designs {pagination?.total || ""}
              </h4>
              {/*   )} */}
              {designs?.length > 0 && (
                <a
                  href="/mydesigns"
                  onClick={() =>
                    trackAnalyticsEvent("root_view_all_designs_click", {
                      source: "your_designs_section",
                    })
                  }
                >
                  View all
                </a>
              )}
            </div>

            <div className="your-design-section-list">
              {designs &&
                designs.slice?.(0, 7).map((design) => {
                  const updatedAt = moment(design.updated_at);
                  const now = moment();
                  const diffMinutes = now.diff(updatedAt, "minutes");
                  const diffHours = now.diff(updatedAt, "hours");
                  const diffDays = now.diff(updatedAt, "days");

                  let timeAgo = "";
                  if (diffMinutes < 60) {
                    timeAgo = `Edited ${diffMinutes}min ago`;
                  } else if (diffHours < 24) {
                    timeAgo = `Edited ${diffHours}h ago`;
                  } else {
                    timeAgo = `Edited ${diffDays}d ago`;
                  }

                  return (
                    <div
                      key={design.id}
                      className="your-design-section-item"
                      onClick={(e) => {
                        trackAnalyticsEvent("root_open_existing_design", {
                          design_id: design.id,
                          source: "your_designs_section",
                        });
                        e.stopPropagation();
                        // window.location.href = `/Design/${design.id}`;
                        window.open(`/Design/${design.id}`, "_blank");
                      }}
                    >
                      <div className="your-design-section-item-img">
                        {design.design_thumbnail_url && (
                          <img
                            src={
                              design.design_thumbnail_url ||
                              "/assets/images/dimg01.png"
                            }
                            alt={design.design_name}
                            onError={(e) => {
                              e.target.src = "/assets/images/dimg01.png";
                            }}
                          />
                        )}
                      </div>
                      <h5>{design.design_name}.tdx</h5>
                      <h6>{timeAgo}</h6>
                      {userData?.type === "admin" && (
                        <h6>{design.user_name}</h6>
                      )}
                      <div
                        className="your-design-section-item-more"
                        style={{ padding: "0" }}
                      >
                        <button
                          className="more-button"
                          style={{
                            background: "none",
                            border: "none",
                            padding: "1rem",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e) => {
                            // Prevent event bubbling to parent
                            e.preventDefault();
                            e.stopPropagation();

                            // Toggle menu visibility
                            const menu = e.currentTarget.nextElementSibling;
                            menu.style.display =
                              menu.style.display === "none" ? "block" : "none";
                          }}
                        >
                          <img
                            src={"/assets/images/more_icn.svg"}
                            alt="more icon"
                          />
                        </button>
                        <div
                          className="more-menu"
                          style={{
                            display: "none",
                            position: "absolute",
                            right: "0",
                            top: "100%",
                            background: "#fff",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                            borderRadius: "4px",
                            zIndex: 1000,
                          }}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              const designId = design.id;

                              setShowModal(true);
                              setSelectedDesignId(designId);
                              setNewDesignName(design.design_name);
                              e.currentTarget.parentElement.style.display =
                                "none";
                            }}
                            style={{
                              display: "block",
                              width: "100%",
                              padding: "8px 16px",
                              border: "none",
                              background: "none",
                              textAlign: "left",
                              cursor: "pointer",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f5f5f5")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "transparent")
                            }
                          >
                            Rename
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              const designId = design.id;

                              setShowDeleteModal(true);
                              setSelectedDesignId(designId);
                              setNewDesignName(design.design_name);
                              e.currentTarget.parentElement.style.display =
                                "none";
                            }}
                            style={{
                              display: "block",
                              width: "100%",
                              padding: "8px 16px",
                              border: "none",
                              background: "none",
                              textAlign: "left",
                              cursor: "pointer",
                              color: "#ff4444",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#fff1f1")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "transparent")
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}

              {/* Static design items for reference - commented out for dynamic implementation */}
              {/* 
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg01.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
               
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg02.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg02.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg01.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg02.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
                <div className="your-design-section-item">
                  <div className="your-design-section-item-img">
                    <img src={"/assets/images/dimg02.png"} alt="" />
                  </div>
                  <h5>Name limit example.TDX</h5>
                  <h6>23MB • Edited 15min ago</h6>
                  <div className="your-design-section-item-more">
                    <img src={"/assets/images/more_icn.svg"} alt="" />
                  </div>
                </div>
              */}
            </div>
          </div>
        </section>
      </div>
      <PrivateFooter />
    </>
  );
}

export default Home;
